import { Link, createFileRoute } from "@tanstack/react-router";
import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";
import Author from "#/components/author";
import { fmPerson } from "#/lib/jsonLdSchema";
import { toAppPath } from "#/lib/router-links";
import { metadataToHead } from "#/lib/seo";

export default function Page() {
  return (
    <>
      <header>
        <NavBar />
      </header>
      <main id="content" className="mx-auto mt-24 max-w-3xl space-y-10">
        <h1 className="text-center text-5xl">Frank Melo, MD</h1>

        <Author />

        <p className="pt-5">
          {messageIcon}
          Be sure to connect and send a message on Linkedin. Here is my{" "}
          <a
            href="https://www.linkedin.com/in/frank-melo"
            rel="noopener noreferrer"
            target="_blank"
          >
            Anesthesiologist Physician Linkedin profile.
          </a>
        </p>

        <section>
          <h2 className="mb-5 mt-10 text-3xl">Authored Articles</h2>

          <ol>
            <li>
              <Link {...toAppPath("/anesthesiologist-salary")}>
                Anesthesiologist Salary
              </Link>
            </li>
            <li>
              <Link {...toAppPath("/anesthesiologist-cv-examples")}>
                CV Examples for Anesthesiologists
              </Link>
            </li>
            <li>
              <Link {...toAppPath("/locum-work-physicians-guide")}>
                How Does Locum Tenens Work for Physicians
              </Link>
            </li>
            <li>
              <Link {...toAppPath("/part-time-anesthesiology-work")}>
                Guide to Working Part-Time in Anesthesiology
              </Link>
            </li>
            <li>
              <Link {...toAppPath("/locum-tenens-agencies")}>
                Top Locum Agencies & How to Choose
              </Link>
            </li>
            <li>
              <Link {...toAppPath("/anesthesiology-job-boards")}>
                List of Job Boards for Anesthesiologists
              </Link>
            </li>
          </ol>
        </section>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={addJsonLd()}
      />
    </>
  );
}

const messageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="mr-3 inline h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
    />
  </svg>
);

export const metadata = {
  title: "Frank Melo, MD • Anesthesiologist Physician",
  description:
    "I'm Dr. Francisco J. Melo, a dedicated Anesthesiologist with a career spanning over 35 years. My journey in medicine has been marked by anesthetic care in both small towns and rural areas.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/about-roamdoc/frank-melo-md`,
  },
};

function addJsonLd() {
  return {
    __html: `{
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        "dateCreated": "2024-01-01T12:00:00-05:00",
        "dateModified": "2024-01-24T14:00:00-05:00",
        "mainEntity": ${JSON.stringify(fmPerson())},
        "hasPart": [
          {
            "@type": "Article",
            "headline": "Anesthesiologist Salary in the United States",
            "url": "https://www.roamdoc.com/anesthesiologist-salary",
            "author": { "@id": "#frank-melo-md" }
          },
          {
            "@type": "Article",
            "headline": "CV Examples for Anesthesiologists",
            "url": "https://www.roamdoc.com/anesthesiologist-cv-examples",
            "author": { "@id": "#frank-melo-md" }
          },
          {
            "@type": "Article",
            "headline": "How Does Locum Tenens Work for Physicians",
            "url": "https://www.roamdoc.com/locum-work-physicians-guide",
            "author": { "@id": "#frank-melo-md" }
          },
          {
            "@type": "Article",
            "headline": "Guide to Working Part-Time in Anesthesiology",
            "url": "https://www.roamdoc.com/part-time-anesthesiology-work",
            "author": { "@id": "#frank-melo-md" }
          },
          {
            "@type": "Article",
            "headline": "Top Locum Agencies & How to Choose",
            "url": "https://www.roamdoc.com/locum-tenens-agencies",
            "author": { "@id": "#frank-melo-md" }
          },
          {
            "@type": "Article",
            "headline": "List of Job Boards for Anesthesiologists",
            "url": "https://www.roamdoc.com/anesthesiology-job-boards",
            "author": { "@id": "#frank-melo-md" }
          }
        ]
      }`,
  };
}

export const Route = createFileRoute("/about-roamdoc/frank-melo-md/")({
  component: Page,
  head: () => metadataToHead(metadata),
});
